import { RootState } from 'lib/stores';

export const currentUserSelector = (state: RootState) => state.auth.currentUser;
